(function () {
  const BULK_PRICING_KEY = 'mtc_bulk_pricing';

  // Shared HTML-escape helper. Defined here because mtc-card-badges.js is always
  // loaded before mtc-product-card.js, which consumes the same window.Mtc.escHtml.
  window.Mtc = window.Mtc || {};
  window.Mtc.escHtml =
    window.Mtc.escHtml ||
    function (str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    };
  const escHtml = window.Mtc.escHtml;

  function getBulkPricing() {
    try {
      return JSON.parse(localStorage.getItem(BULK_PRICING_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function buildBulkBadge(handle, variantAvailable) {
    const bulkData = getBulkPricing()[handle];
    const badge = window.mtcBulkBadge;
    if (!bulkData || !variantAvailable || !badge) return '';
    const badgePrice = `£${(bulkData.price / 100).toFixed(2)}`;
    const colorAttr = badge.color ? ` style="background:${escHtml(badge.color)}"` : '';
    return `<div class="bulk-rate-badge"${colorAttr}>
      <div class="bulk-rate-badge__quantity">
        <div class="bulk-rate-badge__number">${escHtml(String(bulkData.qty))}</div>
        <img src="${escHtml(badge.imageUrl)}" alt="" class="bulk-rate-badge__img" width="20" height="20" loading="lazy">
      </div>
      <div class="bulk-rate-badge__price">
        ${badgePrice} <span class="bulk-rate-badge__price—each">${escHtml(badge.eachLabel)}</span>
      </div>
    </div>`;
  }

  function buildProductBadge(product) {
    const cfg = window.mtcBadges;
    if (!cfg) return '';

    let badgeClass = '';
    let badgeContent = '';
    let badgeStyle = '';

    if (!product.available) {
      badgeClass = cfg.soldOutClass;
      badgeContent = escHtml(cfg.soldOutLabel);
    } else if (product.compare_at_price && product.compare_at_price > product.price) {
      badgeClass = cfg.saleClass;
      badgeContent = escHtml(cfg.saleLabel);
    } else {
      const tags = Array.isArray(product.tags) ? product.tags : [];
      let activeLabel = null;
      if (tags.includes('Pre Order')) activeLabel = 'Pre Order';
else if (tags.includes('Latest Deals')) activeLabel = 'Latest Deals';
else if (tags.includes('Core Essentials')) activeLabel = 'Core Essentials';
else if (tags.includes('Clearance')) activeLabel = 'Clearance';
else if (product.created_at) {
        const ageSeconds = (Date.now() - new Date(product.created_at).getTime()) / 1000;
        if (ageSeconds < 2592000) activeLabel = 'New in';
      }

      if (!activeLabel) return '';

      const entry = cfg.entries[activeLabel];
      if (!entry) return '';

      if (entry.imageUrl) {
        badgeStyle = 'background:none;';
        badgeContent = `<img src="${escHtml(entry.imageUrl)}" alt="" loading="lazy">`;
      } else {
        badgeStyle = `background-color:${escHtml(entry.color || '#000')};color:#fff;`;
        badgeContent = escHtml(entry.displayText);
      }
    }

    return `<div class="product-badges product-badges--${escHtml(cfg.position)}" style="${escHtml(cfg.style)}">
      <div class="product-badges__badge product-badges__badge--rectangle ${escHtml(badgeClass)}" style="${badgeStyle}">
        ${badgeContent}
      </div>
    </div>`;
  }

  window.MtcCardBadges = { buildBulkBadge, buildProductBadge };
})();
